// extracted by mini-css-extract-plugin
module.exports = {"itemCard":"table-item_itemCard__qI76x","item":"table-item_item__nbsco","itemImg":"table-item_itemImg__FSwGd","head":"table-item_head___plQ3","subText":"table-item_subText__97Amj"};